import { AccountBalance, InternalAccount } from "@wingspanhq/wingspan-api-sdk";
import takeRight from "lodash/takeRight";

import { selectorAccountBalance } from "../../../shared/selectors/selectorAccountBalance";
import { PayrollRunsWalletBalance } from "../types";

type Input = {
  internalAccount?: InternalAccount;
  balance?: AccountBalance;
};

/** Adapt the funding internal account + its balance into the wallet card model. */
export const selectorPayrollRunsWalletBalance = ({
  internalAccount,
  balance
}: Input): PayrollRunsWalletBalance => {
  const amounts = selectorAccountBalance(balance);

  return {
    accountMask: takeRight(
      (internalAccount?.numbers?.account ?? "").split(""),
      4
    ).join(""),
    availableBalance: amounts.available,
    currentBalance: amounts.balance,
    pendingAmount: amounts.pending
  };
};
